import type { PreloadedCampaignLibrary } from '@/components/CampaignVideoCard';

export type CommunityLibraryMatch = {
  id: string;
  name: string;
  base_video_url?: string | null;
  duration_seconds: number;
  format: string;
  language: string;
  start_time?: number | null;
  end_time?: number | null;
  channelId?: string | null;
  active_cpm_campaigns?: Array<{ id: string }> | null;
};

export function communityMatchToPreloadedLibrary(
  match: CommunityLibraryMatch,
): PreloadedCampaignLibrary {
  return {
    id: match.id,
    name: match.name,
    base_video_url: match.base_video_url,
    duration_seconds: match.duration_seconds,
    format: match.format,
    language: match.language,
    start_time: match.start_time,
    end_time: match.end_time,
    active_cpm_campaigns: match.active_cpm_campaigns,
  };
}

export function buildCampaignLibraryDeepLink(
  campaignId: string,
  match: CommunityLibraryMatch,
): {
  pathname: string;
  search: string;
  state: { preloadedLibrary: PreloadedCampaignLibrary };
} {
  const params = new URLSearchParams();
  params.set('libraryId', match.id);

  return {
    pathname: `/campaigns/${campaignId}`,
    search: params.toString(),
    state: { preloadedLibrary: communityMatchToPreloadedLibrary(match) },
  };
}

export function buildCommunityLibraryDeepLink(match: CommunityLibraryMatch): {
  pathname: string;
  search: string;
  state: { preloadedLibrary: PreloadedCampaignLibrary };
} {
  const params = new URLSearchParams();
  if (match.channelId) {
    params.set('channelId', match.channelId);
  }
  params.set('libraryId', match.id);

  return {
    pathname: '/community-library',
    search: params.toString(),
    state: { preloadedLibrary: communityMatchToPreloadedLibrary(match) },
  };
}
